import * as React from 'react';
import { Icon } from '../Icon/Icon';

export interface IMobileMenuOverlayProps {
    items: MenuItem[];
    searchUrl: string;
}

class MenuItem {
    public id: string;
    public url: string;
    public name: string;
    public icon: string;
    public active: boolean;
}

interface IMobileMenuOverlayState {
    searchtext: string;
}

export class MobileMenuOverlay extends React.Component<IMobileMenuOverlayProps, IMobileMenuOverlayState> {
    constructor(props: IMobileMenuOverlayProps) {
        super(props);
        this.state = { searchtext: '' };
    }

    public searchkeydown(event: React.KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.search();
        }
    }

    public search(): void {
        if (this.props.searchUrl === undefined || this.props.searchUrl === null || this.props.searchUrl === '') {
            return;
        }

        window.location.href = this.props.searchUrl + '?query=' + encodeURI(this.state.searchtext);
    }

    public handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({ searchtext: event.target.value });
    }

    public renderItem(item: MenuItem, index: number): JSX.Element {
        const icon = item.icon ?? '';

        let linkClass = 'mobile-menu-overlay__item';

        if (item.active) {
            linkClass += ' mobile-menu-overlay__item--active';
        }

        return (
            <li key={index} className={linkClass}>
                <a className="d-flex align-items-center" href={item.url}>
                    <div className="mobile-menu-overlay__icon">
                        <Icon symbol={icon} />
                    </div>
                    <div className="mobile-menu-overlay__text">{item.name}</div>
                </a>
            </li>
        );
    }

    public render(): JSX.Element {
        return (
            <div className="mobile-menu-overlay container-fluid d-lg-none d-flex flex-column" aria-live="polite">
                {this.renderSearch.apply(this)}
                <ul>{this.props.items.map(this.renderItem.bind(this))}</ul>
            </div>
        );
    }

    private renderSearch(): JSX.Element {
        if (this.props.searchUrl === undefined || this.props.searchUrl === null || this.props.searchUrl === '') {
            return;
        }

        return (
            <div className="mobile-menu-overlay__search">
                <input
                    type="search"
                    className="mobile-menu-overlay__search-input"
                    placeholder="Sök på trafiken.nu"
                    value={this.state.searchtext}
                    onKeyDown={this.searchkeydown.bind(this)}
                    onChange={this.handleChange.bind(this)}
                />
                <span className="icon-search icon-flip-horizontal" onClick={this.search.bind(this)} />
            </div>
        );
    }
}
